export default {"src":"/_next/static/media/Post-Surgical Recovery.2eb166d2.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};